import { createContext } from "react";
var FlagsContext = createContext({});
export {
  FlagsContext
};
//# sourceMappingURL=FlagsContext.js.map
